import type { ServiceCode } from 'common/enums/ServiceCode';
import type { ReactNode } from 'react';
import { createContext } from 'react';

export type LatestCarePathContextValue = Readonly<{
    serviceCode: ServiceCode;
}>;

export const LatestCarePathContext = createContext<LatestCarePathContextValue | null>(null);

export function LatestCarePathContextProvider({
    children,
    value,
}: Readonly<{
    children: ReactNode;
    value: LatestCarePathContextValue;
}>) {
    return <LatestCarePathContext.Provider value={value}>{children}</LatestCarePathContext.Provider>;
}
